module.exports = __webpack_public_path__ + "img/pencil-hover.07368019.svg";